define([
	'jquery',
    "shared.main.screen"
], function($, screenSize) {

    var DEBUG = false, // make true to enable debug output
        PLUGIN_IDENTIFIER = "pdpMobileSocialShare";

    // Create the function that will be bound to JQuery
    var vfdpPlugin = function (element, options) {
        this.element = element;
        this.options = options;
    };

    vfdpPlugin.prototype = {

        defaults: {
            modalOptions: {
                enabled: false,
                largeOnly: true, //Usually devices have native share capabilities
                modalSelector: '.reveal-overlay > .social-media-share-modal-container',
                copyButtonSelector: '.social-widget-container .copy-link-js',
                inputSelector: '.social-widget-container .social-widget-input'
            }
        },

        init: function() {
            var self = this;
            if(DEBUG) console.log('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + 'Options');
            self.config = $.extend(true,
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            self.canonicalUrl = $("link[rel='canonical']").attr('href');
            self.$modal = $(self.config.modalOptions.modalSelector);

            self.checkCompatibility();
            self.events();

            return self;
        },

        events: function() {
            if(DEBUG) console.log('addEventHandlers');
            var self = this;

            if( self.config.modalOptions.enabled ){
                self.$modal.on('open.zf.reveal', function() {
                    self.$modalCopyButton = $(self.config.modalOptions.copyButtonSelector);
                    self.$modalInput = $(self.config.modalOptions.inputSelector);
                    self.$modalCopyButton.click(function(){
                        navigator.clipboard.writeText(self.$modalInput[0].value);
                    });
                });
            }

            $(self.element).click(function() {
                if( self.config.modalOptions.enabled && screenSize.size() !== 'medium' && screenSize.size() !== 'small' ){
                    self.$modal.foundation('open');
                }
                else {
                    self.handleWebShare();
                }
            });

            this.swatchClick = $.pubsub('subscribe', 'product-form.attr.swatch.click', function(event, data) {
                self.updateSocialLinkData(data.target);
            });
        },

        checkCompatibility: function() {
            if(DEBUG) console.log('checkCompatibility');
            var self = this;

            if (!navigator.share) {
                $(self.element).addClass('hide');
            }
        },

        handleWebShare: function() {
            if(DEBUG) console.log('handleWebShare');
            var self = this;

            var shareData = {
                title: $(self.element).data('title'),
                text: $(self.element).data('description'),
                url: decodeURIComponent($(self.element).data('url'))
            };

            if (navigator.share) {
                navigator.share(shareData)
                .then(function() {
                    if(DEBUG) console.log('Successful share');
                })
                .catch(function(error) {
                    if(DEBUG) console.log('Error sharing', error);
                });
            } else {
                if(DEBUG) console.log('No navigator');
            }
        },

        updateSocialLinkData: function(colorElement) {
            if(DEBUG) console.log('updateAllSocialLinkData');
            var self = this;

            colorElement = colorElement || $('.color-swatches-js .attr-box.selected .color-swatch-button-content');
            var url = encodeURIComponent(self.canonicalUrl + "?variationId=" + $(colorElement).data('variationId'));
            $(self.element).attr('data-url', url);
        }
    };

    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;
    vfdpPlugin.prototype = $.extend({}, vfdpPlugin.prototype);

    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        if(DEBUG) console.log('$.fn[', PLUGIN_IDENTIFIER, ']', options);
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
